<template>
  <div>
    <el-dialog :visible.sync="dialogFormVisible" width="498px" :lock-scroll="false" :close-on-click-modal="false">
      <div slot="title" class="dialog-header">
        <div class="dialog-header-logo">
          <img :src="loginImage" />
        </div>
        <div class="dialog-header-tab">
          <div class="tab-1 tab-1-active">
            {{ activeTab == 0 ? $t('nav.nav_email_verify_back') : $t('nav.nav_phone_verify_back') }}
          </div>
        </div>
      </div>
      <el-form :model="form">
        <div v-if="activeTab == 0">
          <el-form-item :error="errorAccount">
            <el-input
              v-model="form.account"
              :placeholder="$t('login.login28')"
              autoComplete="username"
              clearable></el-input>
          </el-form-item>
          <el-form-item :error="errorCode">
            <el-input
              v-model="form.code"
              @input="handleInput"
              maxlength="6"
              :placeholder="$t('login.login29')"
              autoComplete="one-time-code">
              <el-button
                type="text"
                :loading="loadingCode"
                slot="append"
                :class="form.account ? 'input-code-active' : ''"
                class="input-code"
                @click="getCode()">
                {{ codeText.length > 5 ? $t(`${codeText}`) : codeText }}
              </el-button>
            </el-input>
          </el-form-item>
          <el-form-item :error="errorPassword">
            <el-input
              :type="pwdType"
              v-model="form.password"
              :οnkeyup="(form.password = form.password.replace(/[\u4e00-\u9fa5 ]/gi, ''))"
              :maxlength="16"
              :placeholder="$t('login.login30')"
              autoComplete="new-password">
              <img
                :src="seeImage"
                class="see-img"
                v-if="pwdType == 'password' && form.password"
                @click="changePwType('text', 0)"
                slot="suffix" />
              <img
                :src="see2Image"
                class="see-img"
                v-if="pwdType == 'text' && form.password"
                @click="changePwType('password', 0)"
                slot="suffix" />
            </el-input>
          </el-form-item>
          <el-form-item :error="errorPassword2">
            <el-input
              :type="confirmPwdType"
              v-model="form.password2"
              :οnkeyup="(form.password2 = form.password2.replace(/[\u4e00-\u9fa5 ]/gi, ''))"
              :maxlength="16"
              :placeholder="$t('login.login31')"
              autoComplete="new-password">
              <img
                :src="seeImage"
                class="see-img"
                v-if="confirmPwdType == 'password' && form.password2"
                @click="changePwType('text', 1)"
                slot="suffix" />
              <img
                :src="see2Image"
                class="see-img"
                v-if="confirmPwdType == 'text' && form.password2"
                @click="changePwType('password', 1)"
                slot="suffix" />
            </el-input>
          </el-form-item>
        </div>
        <div v-if="activeTab == 1">
          <el-form-item :error="errorAccount">
            <el-input
              v-model="form.account"
              :placeholder="$t('register.register1')"
              autocomplete="off"
              clearable></el-input>
          </el-form-item>
          <el-form-item :error="errorCode">
            <el-input
              v-model="form.code"
              @input="handleInput"
              maxlength="6"
              :placeholder="$t('register.register4')"
              autocomplete="off">
              <el-button
                type="text"
                :loading="loadingCode"
                slot="append"
                :class="form.account ? 'input-code-active' : ''"
                class="input-code"
                @click="getCode()">
                {{ codeText }}
              </el-button>
            </el-input>
          </el-form-item>
          <el-form-item :error="errorPassword">
            <el-input
              v-model="form.password"
              :maxlength="20"
              :placeholder="$t('login.login30')"
              autocomplete="off"
              show-password></el-input>
          </el-form-item>
          <el-form-item :error="errorPassword2">
            <el-input
              v-model="form.password2"
              :maxlength="20"
              :placeholder="$t('login.login31')"
              autocomplete="off"
              show-password></el-input>
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <div class="dialog-footer-button">
          <el-button type="primary" :loading="loadinglogin" @click="login()">{{ $t('login.login32') }}</el-button>
        </div>
        <div class="dialog-footer-bottom">
          <div class="to-login" @click="changeUpdateType()">
            {{ activeTab == 0 ? $t('nav.nav_phone_verify_back') : $t('nav.nav_email_verify_back') }}
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
const loginImage = require('../assets/img/login/login.png');
const seeImage = require('../assets/img/login/see.png');
const see2Image = require('../assets/img/login/see2.png');

import { getLogin, getLoginCode, getSendMSM, getForgotPW } from '../../common/api';
import md5 from 'js-md5';
import { filters } from '../../common/filters.js';
export default {
  data() {
    return {
      loginImage,
      seeImage,
      see2Image,
      pwdType: 'password', //密码类型
      confirmPwdType: 'password', //确认密码类型
      dialogFormVisible: false, //弹窗显示状态
      activeTab: 0, //切换下标 0手机1邮箱
      form: {
        account: '',
        password: '',
        password2: '',
        code: ''
      }, //表单
      codeText: this.$t('login.login14'), //获取
      areaCode: '+86', //区号
      countDownTimer: 60, //倒计时
      verification: true, //验证是否可获取
      errorAccount: '', //错误账号提示
      errorPassword: '', //错误密码提示
      errorPassword2: '', //错误密码提示
      errorCode: '', //错误验证码提示
      language: 'zh', //默认语言
      sendCodeTimer: null, //发送验证码时间类
      loadingCode: false, //验证码加载状态
      loadinglogin: false //登录加载状态
    };
  },
  watch: {
    'form.account': {
      handler: function (val, old) {
        if (val == '') {
          this.errorAccount = '';
        }
        var reg = filters.regPwd(1);
        if (reg.test(val)) {
          this.errorAccount = '';
        }
      }
    },
    'form.code': {
      handler: function (val, old) {
        if (val == '' || val.length == 4) {
          this.errorCode = '';
        }
      }
    },
    'form.password': {
      handler: function (val, old) {
        if (val == '') {
          this.errorPassword = '';
        }
        var reg = filters.regPwd(0);
        if (reg.test(val)) {
          this.errorPassword = '';
        }
      }
    },
    'form.password2': {
      handler: function (val, old) {
        if (val == '') {
          this.errorPassword2 = '';
        }
        var reg = filters.regPwd(0);
        if (reg.test(val)) {
          this.errorPassword2 = '';
        }
      }
    }
  },
  mounted() {
    let lang = localStorage.getItem('lang') || filters.getLocale();
    this.language = lang;
  },
  methods: {
    initData() {
      this.form.account = '';
      this.form.password = '';
      this.form.password2 = '';
      this.form.code = '';
      this.verification = true;
      this.codeText = this.$t('login.login14');
      clearInterval(this.sendCodeTimer);
    },
    /**
     * 切换验证方式
     */
    changeUpdateType() {
      if (this.activeTab == 0) {
        this.activeTab = 1;
      } else {
        this.activeTab = 0;
      }
      this.initData();
    },
    /**
     * @param {Object} type text password
     * @param {Object} index 0 pwdType 1confirmPwdType
     */
    changePwType(type, index) {
      if (index == 0) {
        this.pwdType = type;
      } else {
        this.confirmPwdType = type;
      }
    },
    handleInput(value) {
      const reg = /^[\d\.]+$/;
      if (value && !reg.test(value)) {
        this.form.code = value.replace(/[^\d\.]/g, '');
      }
    },
    changeTab(index) {
      this.activeTab = index;
      this.form.account = '';
      this.form.password = '';
      this.form.code = '';
    },
    toLogin() {
      this.initData();
      this.dialogFormVisible = false;
    },
    login() {
      if (this.activeTab == 0) {
        if (this.form.account == '') {
          this.errorAccount = this.$t('nav.nav_email_fail');
          return;
        } else {
          this.errorAccount = '';
        }
        var reg = filters.regPwd(1);
        if (!reg.test(this.form.account)) {
          this.errorAccount = this.$t('nav.nav_email_fail');
          return;
        } else {
          this.errorAccount = '';
        }
      } else {
        if (this.form.account == '') {
          this.errorAccount = this.$t('nav.nav_phone_fail');
          return;
        } else {
          this.errorAccount = '';
        }
        var reg = filters.regPwd(2);
        if (!reg.test(this.form.account)) {
          this.errorAccount = this.$t('nav.nav_phone_fail');
          return;
        } else {
          this.errorAccount = '';
        }
      }

      if (this.form.code == '' || this.form.code.length < 6) {
        this.errorCode = this.$t('nav.nav_code_fail');
        return;
      } else {
        this.errorCode = '';
      }
      if (this.form.password == '') {
        this.errorPassword = this.$t('login.login17');
        return;
      } else {
        this.errorPassword = '';
      }
      var reg = filters.regPwd(0);
      if (!reg.test(this.form.password)) {
        this.errorPassword = this.$t('register.register20');
        return;
      } else {
        this.errorPassword = '';
      }
      //再次密码
      if (this.form.password2 == '') {
        this.errorPassword2 = this.$t('login.login17');
        return;
      } else {
        this.errorPassword2 = '';
      }
      var reg = filters.regPwd(0);
      if (!reg.test(this.form.password2)) {
        this.errorPassword2 = this.$t('register.register20');
        return;
      } else {
        this.errorPassword2 = '';
      }
      if (this.form.password != this.form.password2) {
        this.errorPassword2 = this.$t('register.register22');
        return;
      } else {
        this.errorPassword2 = '';
      }
      const params = {
        account: this.form.account.trim(),
        code: this.form.code,
        pwd: md5(this.form.password.trim())
      };
      this.loadinglogin = true;
      getForgotPW(params).then((res) => {
        this.loadinglogin = false;
        if (res.code == 0) {
          this.$message({
            showClose: true,
            message: this.$t('login.login34'),
            type: 'success'
          });
          this.dialogFormVisible = false;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    /**
     * @param {Object} index
     */
    getCode() {
      if (this.activeTab == 0) {
        if (this.form.account == '') {
          this.errorAccount = this.$t('nav.nav_email_fail');
          return;
        } else {
          this.errorAccount = '';
        }
        var reg = filters.regPwd(1);
        if (!reg.test(this.form.account)) {
          this.errorAccount = this.$t('nav.nav_email_fail');
          return;
        } else {
          this.errorAccount = '';
        }
      } else {
        if (this.form.account == '') {
          this.errorAccount = this.$t('nav.nav_phone_fail');
          return;
        } else {
          this.errorAccount = '';
        }
        var reg = filters.regPwd(2);
        if (!reg.test(this.form.account)) {
          this.errorAccount = this.$t('nav.nav_phone_fail');
          return;
        } else {
          this.errorAccount = '';
        }
      }
      if (!this.verification) {
        return;
      }
      let params = {
        account: this.form.account.trim(),
        country_code: this.activeTab == 0 ? '' : this.areaCode,
        sms_type: 3, //1注册  2 登录  3忘记密码
        code_size: 6
      };
      this.loadingCode = true;
      getSendMSM(params).then((res) => {
        this.loadingCode = false;
        if (res.code == 0) {
          this.$message({
            showClose: true,
            message: this.$t('login.login20'),
            type: 'success'
          });
          this.form.code = res.data.code;
          this.verification = false;
          setTimeout(() => {
            this.countDownTimer = 60;
            this.codeText = this.countDownTimer + 's';

            this.countDown();
          }, 1000);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    countDown() {
      this.sendCodeTimer = setInterval(() => {
        this.countDownTimer--;
        this.codeText = this.countDownTimer + 's';
        if (this.countDownTimer <= 0) {
          this.codeText = 'login.login14';
          this.verification = true;
          clearInterval(this.sendCodeTimer);
        }
      }, 1000);
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .el-input__inner {
  border: none !important;
}

::v-deep .el-input-group__append {
  border: none !important;
}

::v-deep .el-form-item__content {
  border: 1px solid #e5e5e5;
  border-radius: 4px;
}

::v-deep .el-input__suffix-inner {
  // border-right: 1px solid #E5E5E5;
  // padding-right: 7px;
}

::v-deep .el-popup-parent--hidden {
  padding-right: 0 !important;
}

::v-deep .el-dialog__body {
  padding: 30px 44px 16px !important;
}

::v-deep .dialog-footer .el-button {
  width: 410px;
  height: 45px;
  background: #10b1a7;
  border-radius: 4px 4px 4px 4px;

  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: 400;
  font-size: 14px;
  color: #ffffff;
  line-height: 16px;
  text-align: center;
  font-style: normal;
  text-transform: none;
}

::v-deep .el-button--primary {
  border-color: #10b1a7 !important;
}

::v-deep .el-input__inner {
  border: 1px solid #e5e5e5;
}

::v-deep .el-input__inner:focus {
  border-color: #e5e5e5;
}

::v-deep .el-dialog__header {
  padding: 10px 44px 0 !important;
}

::v-deep .el-dialog__footer {
  padding: 10px 44px 32px !important;
}

::v-deep .el-dialog__headerbtn {
  top: 30px !important;
}

::v-deep .el-dialog__headerbtn .el-dialog__close {
  font-size: 24px !important;
  color: #909399 !important;
}

::v-deep .el-input__inner {
  height: 45px;
  line-height: 45px;
}

::v-deep .el-input-group__prepend {
  width: 150px;
  padding: 0 0 0 16px !important;

  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: 400;
  font-size: 14px;
  color: #333333;
  line-height: 16px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}

::v-deep .el-select {
  width: 90px;
  margin: -10px 0 !important;
}

::v-deep .el-input-group__prepend {
  background: #fff !important;
  border: none !important;
}

::v-deep .el-input-group__append {
  background-color: #ffffff;
}

::v-deep .el-form-item {
  margin-bottom: 34px;
}

.input-code-active {
  color: #10b1a7 !important;
}

.dialog-header {
  margin-top: 18px;
}

.dialog-header-logo {
  width: 52px;
  height: 42px;
  margin-bottom: 24px;

  img {
    width: 52px;
    height: 42px;
  }
}

.dialog-header-tab {
  display: flex;

  .tab-1 {
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 400;
    font-size: 20px;
    color: #333333;
    line-height: 23px;
    text-align: left;
    font-style: normal;
    text-transform: none;
    margin-right: 48px;
    cursor: pointer;
  }

  .tab-1-active {
    color: #10b1a7;
    position: relative;
  }

  .tab-1-active::before {
    content: '';
    position: absolute;
    left: 20%;
    right: 20%;
    height: 3px;
    bottom: -10px;
    background-color: #10b1a7;
  }
}

.dialog-footer {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  .dialog-footer-bottom {
    display: flex;
    flex-direction: column;
    margin-top: 12px;
    width: 100%;

    .to-login {
      font-family: Source Han Sans CN, Source Han Sans CN;
      font-weight: 400;
      font-size: 14px;
      color: #10b1a7;
      line-height: 16px;
      text-align: center;
      font-style: normal;
      text-transform: none;
      cursor: pointer;
    }

    .dialog-footer-button {
    }

    .dialog-footer-agreement {
      display: flex;
      justify-content: space-between;

      .forgot-password {
        font-family: Source Han Sans CN, Source Han Sans CN;
        font-weight: 400;
        font-size: 14px;
        color: #999999;
        line-height: 16px;
        text-align: left;
        font-style: normal;
        text-transform: none;
        cursor: pointer;
      }

      .register {
        font-family: Source Han Sans CN, Source Han Sans CN;
        font-weight: 400;
        font-size: 14px;
        color: #10b1a7;
        line-height: 16px;
        text-align: left;
        font-style: normal;
        text-transform: none;
        cursor: pointer;
      }
    }

    .dialog-footer-agreement-tips {
      display: flex;
      justify-content: center;
      margin-top: 24px;

      font-family: Source Han Sans CN, Source Han Sans CN;
      font-weight: 400;
      font-size: 12px;
      color: #333333;
      line-height: 14px;
      text-align: left;
      font-style: normal;
      text-transform: none;
    }

    .dialog-footer-agreement-tips .active {
      color: #10b1a7;
      cursor: pointer;
    }
  }
}

.input-code {
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: 400;
  font-size: 14px;
  color: #999999;
  line-height: 16px;
  text-align: left;
  font-style: normal;
  text-transform: none;
  cursor: pointer;
  border-left: 1px solid #e5e5e5 !important;
  padding-left: 21px;
  border-radius: 0;
  margin: 0px 3px !important;
}

.input-hr {
  height: 30px;
  width: 1px;
  color: #e5e5e5;
}

.input-code:hover {
  color: #10b1a7;
}
.see-img {
  margin-top: 13px;
  margin-right: 5px;
  width: 20px;
  height: 20px;
  cursor: pointer;
}
</style>
